export enum promoModals {
  REFILL_PROMO = 'REFILL_PROMO',
}
